<template>
  <div class="wechat">
    <headers></headers>
    <div class="wechat-info1">
      <div class="wechat-info2">
        <img src="../assets/images/wechat/wechat1.png" alt />
      </div>
      <div class="wechat-info3">
        <div class="wechat-info4">
          <h1>微信公众号活动版面</h1>
          <p>广告投放时间（活动时间3天起）：</p>
          <div class="block">
            <el-date-picker
              style="width:100%;"
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <p>请选择广告位：</p>
          <div class="wechat-info5">
            <el-select v-model="value" style="width:70%;" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span style="margin-left:12px;">
              <span>￥100.00</span>/天
            </span>
          </div>
          <p>备注内容：</p>
          <el-input
            style="width:100%;"
            type="textarea"
            placeholder="请输入内容"
            v-model="textarea"
            maxlength="30"
            show-word-limit
          ></el-input>
          <div class="wechat-info6">
            <div class="wechat-info7">
              <p>请上传广告图：</p>
              <img src="../assets/images/wechat/wechat2.png" alt />
            </div>
            <div class="wechat-info7">
              <p>请上传内容长图：</p>
              <img src="../assets/images/wechat/wechat3.png" alt />
            </div>
          </div>
          <button>立即提交</button>
        </div>
      </div>
    </div>
    <div class="small-info1">
      <h3>微信公众号活动版面</h3>
      <div class="box1">
        <p>广告投放时间（活动时间3天起）：</p>
        <el-date-picker
          v-model="value6"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
        ></el-date-picker>
      </div>
      <div class="box1">
        <p>请选择广告位：</p>
        <el-select v-model="form.region" placeholder="请选择">
          <el-option label="一个月" value="1"></el-option>
          <el-option label="两个月" value="2"></el-option>
        </el-select>
        <span>
          <i>￥100元/</i> 天
        </span>
      </div>
      <div class="box1">
        <p>备注内容：</p>
        <el-input type="textarea" v-model="form.desc"></el-input>
      </div>
      <div class="box1">
        <span>请上传广告图：</span>
        <img src="../assets/images/wechat/wechat2.png" width="18px" alt />&nbsp;&nbsp;&nbsp;&nbsp;
        <span>请上传内容长图：</span>
        <img src="../assets/images/wechat/wechat3.png" width="18px" alt />
      </div>
      <button>立即提交</button>
    </div>
  </div>
</template>

<script>
import header from "../components/headers";
export default {
  name: "",
  components: {
    headers: header
  },
  data() {
    return {
      value1: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      text: "",
      textarea: "", //备注
      form: {
        region: ""
      },
      value6: ""
    };
  },

  methods: {},
  watch: {}
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}
.wechat {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  padding-bottom: 50px;
  @media screen and (max-width: 850px) {
    .wechat-info1 {
      display: none !important;
    }
  }
  @media screen and (min-width: 850px) {
    .small-info1 {
      display: none;
    }
  }
  .small-info1 {
    padding: 100px 35px;
    h3 {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 3.6px;
      color: #323232;
      margin-bottom: 22px;
    }
    .box1 {
      margin-bottom: 15px;
      .el-date-editor--daterange.el-input__inner {
        width: 100%;
      }
      span {
        font-size: 12px;
        margin-left: 10px;
        i {
          font-style: normal;
          color: #fda700;
        }
      }
    }
    button {
      background-color: #258ffc;
      border-radius: 3.5px;
      border: 1px solid #dcdcdc;
      width: 86px;
      height: 30px;
      color: #fff;
      margin-top: 40px;
    }
  }

  .wechat-info1 {
    width: 70%;
    margin: 0 auto;
    display: flex;
    min-width: 1300px;
    .wechat-info2 {
      width: 38%;
      height: 750px;
      box-shadow: 14px -1px 20px 0px rgba(18, 132, 247, 0.3);
      border-radius: 2px;
      margin-top: 114px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .wechat-info3 {
      width: 60%;
      height: 750px;
      margin-top: 114px;
      border-radius: 2px;
      box-shadow: 0px 4px 35px 3px rgba(107, 108, 109, 0.2);
      padding-left: 70px;
      padding-right: 133px;
      .wechat-info4 {
        margin: 20px 80px;
        h1 {
          font-size: 36px;
          // margin-bottom: 20px;
          margin-top: 49px;
        }
        p {
          font-size: 18px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(50, 50, 50, 1);
          padding: 39px 0 10px 0;
          &:nth-of-type(1) {
            margin-top: 20px;
          }
        }
        .wechat-info5 {
          display: flex;
          span {
            line-height: 40px;
            span {
              color: #fda700;
            }
          }
        }
        .wechat-info6 {
          display: flex;
          justify-content: space-between;
          .wechat-info7 {
            display: flex;
            justify-content: space-between;
            p {
              padding: 0;
              line-height: 40px;
            }
            img {
              width: 30px;
              height: 30px;
              margin-left: 10px;
              margin-top: 26px;
            }
          }
        }
        button {
          background: #258ffc;
          width: 136px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          color: #fff;
          margin-top: 95px;
          outline: none;
          border: none;
          cursor: pointer;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
